import React from 'react';
import { Navigate } from 'react-router-dom';

const MothersDay = () => {
  // Set to true to enable Mother's Day promotion, false to hide it
  const mothersDayActive = false;

  const expiryDate = new Date('2026-05-12T00:00:00');
  const now = new Date();

  if (!mothersDayActive || now >= expiryDate) return <Navigate to="/" replace />;

  return (
    <div className="mothers-day-page" data-testid="mothers-day-page">
      <section className="mothers-day-hero">
        <img 
          src="https://customer-assets.emergentagent.com/job_fe1c91c4-a8c1-49c7-93bd-706bc696132c/artifacts/wdeqgo5j_vecteezy_ai-generated-heartfelt-mother-s-day-greetings_35597800.jpg"
          alt="Mother's Day roses and tulips bouquet"
          className="mothers-day-hero-img"
        />
        <div className="mothers-day-hero-overlay">
          <div className="container">
            <h1 className="mothers-day-title">Mother's Day, Thoughtfully Given</h1>
            <p className="mothers-day-subtitle">A quiet moment, set aside for rest, renewal, and care.</p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <p className="mothers-day-intro">
            This Mother's Day, offer something more meaningful than a gift — an experience designed to restore balance and create space to truly unwind.
          </p>

          <div className="mothers-day-offers">
            <div className="mothers-day-card" data-testid="gift-card-offer">
              <h2>A Simple, Thoughtful Gift</h2>
              <p className="mothers-day-card-tagline">For those who prefer flexibility, our Mother's Day gift card offers a thoughtful way to give the gift of rest and renewal.</p>
              <div className="mothers-day-price">
                <span className="price-highlight">$150 <span className="price-for">in spa credit for</span> $120</span>
              </div>
              <div className="mothers-day-card-details">
                <p>Available for a limited time.</p>
                <p>Designed to be used toward any massage, facial, or curated experience.</p>
              </div>
              <a
                href="https://www.fresha.com/a/sereno-spa-livingston-manor-43-main-street-kla2zdeh/gift-cards?pId=2492446"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary mothers-day-btn"
                data-testid="purchase-gift-card-btn"
              >
                Purchase Gift Card
              </a>
            </div>

            <div className="mothers-day-card featured" data-testid="signature-experience-offer">
              <h2>The Mother's Day Signature Experience</h2>
              <p className="mothers-day-card-tagline">For those looking to give something more curated, our Mother's Day Signature Experience offers a thoughtfully designed treatment centered on deep rest and renewal.</p>
              <div className="mothers-day-card-details">
                <p>Choose a 60-minute customized massage or signature facial, paired with our Sereno Signature Scent Ritual and a targeted enhancement selected to support individual needs.</p>
                <p>Crafted with care and intention, this experience invites a slower pace — a moment to fully unwind and restore balance.</p>
              </div>
              <div className="mothers-day-price">
                <span className="price-highlight">$165</span>
              </div>
              <a
                href="https://www.fresha.com/book-now/sereno-spa-xw34dhed/services?lid=2572885&oiid=sv%3A27190405&share=true&pId=2492446"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary mothers-day-btn"
                data-testid="reserve-experience-btn"
              >
                Reserve Your Experience
              </a>
            </div>
          </div>

          <p className="mothers-day-closing">
            At Sereno Spa, each visit is designed with quiet detail and intention — creating space to slow down, reset, and feel restored.
          </p>
        </div>
      </section>
    </div>
  );
};

export default MothersDay;
